import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { Block, BlockContent, ImageBlockContent } from '../types';

type Props = {
  block: Block;
  selected: boolean;
  forceHoverState?: boolean;
};

export const ImageBlock = ({ block, selected, forceHoverState = false }: Props) => {
  const [fileUrl, setFileUrl] = React.useState<string | undefined>(undefined);

  const blockContent: ImageBlockContent | undefined = block.content.type === 'image' ? block.content : undefined;

  useEffect(() => {
    const file = blockContent?.file;
    const fileUrl = file ? URL.createObjectURL(file) : undefined;
    if (fileUrl) {
      setFileUrl(fileUrl);
    }
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
      setFileUrl(undefined);
    };
  }, [blockContent?.file]);

  if (!blockContent) {
    return null;
  }

  const renderImageBackgroundNode = (backgroundImageUrl: string) => {
    return <ImageRenderNode url={backgroundImageUrl} fit={blockContent.objectFit} />;
    // return (
    //   <div
    //     key={backgroundImageUrl}
    //     className={classNames('absolute transition-all inset-0 rounded-2xl bg-no-repeat bg-center', {
    //       'bg-contain': blockContent.objectFit === 'contain',
    //       'bg-cover': blockContent.objectFit === 'cover',
    //     })}
    //     style={{
    //       backgroundImage: `url(${backgroundImageUrl})`,
    //     }}
    //   />
    // );
  };

  return (
    <div className={classNames('group w-full h-full relative transition rounded-2xl bg-transparent')}>
      <div
        className={classNames('absolute transition-all inset-0 rounded-2xl', {
          'bg-neue-gray-darker': !blockContent.dominantColor,
        })}
        style={{
          ...(blockContent.dominantColor && { backgroundColor: blockContent.dominantColor }),
        }}
      >
        {fileUrl && renderImageBackgroundNode(fileUrl)}
        {blockContent.url && renderImageBackgroundNode(blockContent.url)}
      </div>
      <div
        className={classNames('absolute inset-0 pointer-events-none rounded-2xl transition border-[2px]', {
          'border-bedrock-black bg-bedrock-black/10': selected,
          'border-transparent bg-bedrock-black/10': forceHoverState,
          'border-transparent bg-transparent group-hover:bg-bedrock-black/10': !forceHoverState && !selected,
        })}
      ></div>
    </div>
  );
};

const ImageRenderNode = ({ url, fit }: { url: string; fit: ImageBlockContent['objectFit'] }) => {
  const [loaded, setLoaded] = React.useState(false);
  const onLoad = () => {
    setLoaded(true);
  };
  return (
    <img
      draggable={false}
      src={url}
      onLoad={onLoad}
      className={classNames('absolute transition-all inset-0 w-full h-full rounded-2xl', {
        'object-contain': fit === 'contain',
        'object-cover': fit === 'cover',
        'opacity-0': !loaded,
        'opacity-100': loaded,
      })}
    />
  );
};
